export default __webpack_public_path__ + "static/media/Huawei.b98f1d4b.jpg";